import styles from "../../../styles/Components/pricing-plan/Subscription.module.css";
import { useSearchParams } from "react-router-dom";
import usePricing from "../../../hooks/usePricing";

function PlanDurationSwitcher({ className = "", style = {}, onChange }) {
  const { yearlyDiscount } = usePricing();
  const [searchParams, setSearchParams] = useSearchParams();
  const planDuration = searchParams.get("duration") || "annual";

  const changeDuration = (duration) => () => {
    searchParams.set("duration", duration);
    setSearchParams(searchParams);
    if (onChange) {
      onChange(duration);
    }
  };

  return (
    <div className={`${styles.planDurations} ${className}`} style={style}>
      <div
        className={`${styles.planDuration} ${planDuration === "monthly" ? styles.selected : ""}`}
        onClick={changeDuration("monthly")}
      >
        Monthly
      </div>
      <div
        className={`${styles.planDuration}  ${planDuration === "annual" ? styles.selected : ""}`}
        onClick={changeDuration("annual")}
      >
        Annual <span className={styles.discount}>-{yearlyDiscount}%</span>
      </div>
    </div>
  );
}

export default PlanDurationSwitcher;
